import { API_BASE_URL } from "./apiConfig";
import { handleApiResponse } from "./apiUtils";

export const createUser = async (userData) => {
  const response = await fetch(`${API_BASE_URL}/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(userData),
  });
  return handleApiResponse(response);
};

export const login = async (credentials) => {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(credentials),
  });
  return handleApiResponse(response);
};

export const resetPasswordWithEmailAndPhone = async (data) => {
  const response = await fetch(`${API_BASE_URL}/users/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(data), // { email, phone, newPassword }
  });
  return handleApiResponse(response);
};

export const getAllUsers = async () => {
    const response = await fetch(`${API_BASE_URL}/users`, {
        headers: {
            'accept': '*/*',
        },
    });
    return handleApiResponse(response);
};

export const getUserById = async (id) => {
  if (!id) return null;
  const response = await fetch(`${API_BASE_URL}/users/${id}`, {
    headers: {
      'accept': '*/*',
    },
  });
  if (response.status === 404) {
    return null;
  }
  return handleApiResponse(response);
};

export const updateUser = async (id, userData) => {
  const response = await fetch(`${API_BASE_URL}/users/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify(userData),
  });
  return handleApiResponse(response);
};

export const resendConfirmationCode = async (email) => {
  const response = await fetch(`${API_BASE_URL}/auth/resend-confirmation-code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': '*/*',
    },
    body: JSON.stringify({ email }),
  });
  return handleApiResponse(response);
};

export const searchUserByEmail = async (email) => {
  if (!email) return [];
  const response = await fetch(`${API_BASE_URL}/users/search?email=${encodeURIComponent(email)}`);
  if (response.status === 404) {
    return [];
  }
  return handleApiResponse(response);
};

export const searchUserByPhone = async (phone) => {
  if (!phone) return [];
  const response = await fetch(`${API_BASE_URL}/users/search?phone=${encodeURIComponent(phone)}`);
  if (response.status === 404) {
    return [];
  } // If 404, it means no user found, which is fine for uniqueness check
  return handleApiResponse(response);
};

export const deleteUser = async (id) => {
  const response = await fetch(`${API_BASE_URL}/users/${id}`, {
    method: 'DELETE',
    headers: {
      'accept': '*/*',
    },
  });
  return handleApiResponse(response);
};
